<app-header></app-header>

<div class="row h100 exhibitor-backoffice">
  <div class="col-12 col-lg-2 h100 exhibitor-backoffice__left">
    <app-menu-exhibitor [active]="'exhibitors'"></app-menu-exhibitor>
  </div>
  <div class="col-12 col-lg-10 exhibitor-backoffice__right">

    <app-menu-exhibitor-sub-menu [active]="'detail'" [exhibitor]="exhibitorData['exhibitor']"></app-menu-exhibitor-sub-menu>

    <div class="exhibitor-backoffice__content">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': activeTab === 1 }" [ngStyle]="{ 'color': activeTab === 1 ? catalogueService.getProperty('mainColor') : '#222222', 'border-bottom-color': activeTab === 1 ? catalogueService.getProperty('mainColor') : 'transparent'  }" href="javascript:void(0)" (click)="setTab(1)">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.BASIC_INFORMATION' | translate }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': activeTab === 2 }" [ngStyle]="{ 'color': activeTab === 2 ? catalogueService.getProperty('mainColor') : '#222222', 'border-bottom-color': activeTab === 2 ? catalogueService.getProperty('mainColor') : 'transparent'  }" href="javascript:void(0)" (click)="setTab(2)">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.MULTIMEDIA' | translate }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'active': activeTab === 3 }" [ngStyle]="{ 'color': activeTab === 3 ? catalogueService.getProperty('mainColor') : '#222222', 'border-bottom-color': activeTab === 3 ? catalogueService.getProperty('mainColor') : 'transparent'  }" href="javascript:void(0)" (click)="setTab(3)">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.CATEGORIES' | translate }}</a>
        </li>
        <li class="nav-item" *ngIf="isOdsActive">
          <a class="nav-link" [ngClass]="{ 'active': activeTab === 4 }" [ngStyle]="{ 'color': activeTab === 4 ? catalogueService.getProperty('mainColor') : '#222222', 'border-bottom-color': activeTab === 4 ? catalogueService.getProperty('mainColor') : 'transparent'  }" href="javascript:void(0)"  (click)="setTab(4)">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.ODS' | translate }}</a>
        </li>
      </ul>
      <form name="form" class="form" #form="ngForm">

        <div [hidden]="activeTab !== 1">
          <app-edit-exhibitor-exhibitor [exhibitorData]="exhibitorData" [eventName]="eventName" [selectedOds]="selectedOds"></app-edit-exhibitor-exhibitor>
        </div>

        <div [hidden]="activeTab !== 2">
          <app-edit-exhibitor-multimedia [exhibitorData]="exhibitorData"></app-edit-exhibitor-multimedia>
        </div>

        <div [hidden]="activeTab !== 3">
          <app-edit-exhibitor-categories [exhibitorData]="exhibitorData"></app-edit-exhibitor-categories>
        </div>

        <div [hidden]="activeTab !== 4">
          <h2>{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.ODS' | translate }}</h2>
          <div class="section-container">
            <div class="form-check" *ngFor="let od of ods">
              <label class="form-check-label" for="{{ od.id }}" >
                <input class="form-check-input" type="checkbox" id="{{ od.id }}" name="{{ od.id }}" [checked]="checkSelectedOds(od.id)" (click)="toggleOd(od.id)">
                {{ utilsService._api(od.translations, 'name') }}
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <button type="button" class="btn btn--submit float-end" (click)="saveBtn()" [disabled]="!form.valid" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">
              {{ 'COMMON.SAVE' | translate }}
            </button>
            <button type="button" class="btn btn--light float-end mx-sm-3" (click)="cancel()">
              {{ 'COMMON.CANCEL' | translate }}
            </button>
          </div>
        </div>

      </form>
    </div>

  </div>
</div>

<app-footer></app-footer>
